import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { toast } from "sonner";

export default function Register() {
  const { register } = useAuth();
  const nav = useNavigate();
  const [form, setForm] = useState({ firstName: "", email: "", password: "" });
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    if (form.password.length < 6) {
      setError("Le mot de passe doit contenir au moins 6 caractères");
      return;
    }
    setLoading(true);
    const res = await register(form.firstName, form.email, form.password);
    setLoading(false);
    if (!res.ok) {
      setError(res.error);
      toast.error(res.error);
      return;
    }
    toast.success("Bienvenue dans le programme");
    nav("/dashboard");
  };

  return (
    <div className="min-h-[calc(100vh-80px)] flex items-center justify-center px-6 py-16" data-testid="register-page">
      <div className="w-full max-w-md glass p-10 fade-up">
        <div className="label-eyebrow mb-3">Nouveau membre</div>
        <h1 className="font-display text-4xl mb-2">Créer un compte</h1>
        <p className="text-[#a3a8a4] text-sm mb-10">Rejoignez le programme et commencez à cumuler.</p>

        <form onSubmit={submit} className="space-y-5" data-testid="register-form">
          <Field label="Prénom" type="text" value={form.firstName} onChange={(v)=>setForm({...form, firstName:v})} testid="register-firstName"/>
          <Field label="Email" type="email" value={form.email} onChange={(v)=>setForm({...form, email:v})} testid="register-email"/>
          <Field label="Mot de passe" type="password" value={form.password} onChange={(v)=>setForm({...form, password:v})} testid="register-password"/>

          {error && <div className="text-red-400 text-sm" data-testid="register-error">{error}</div>}

          <button disabled={loading} type="submit" className="w-full bg-[#d4af37] text-black px-6 py-3.5 font-medium tracking-widest uppercase text-xs hover:bg-[#e6c27a] transition-colors disabled:opacity-50" data-testid="register-submit">
            {loading ? "Création..." : "Créer mon compte"}
          </button>
        </form>

        <div className="mt-8 pt-6 border-t border-[rgba(253,251,247,0.08)] text-sm text-[#a3a8a4]">
          Déjà membre ? <Link to="/login" className="gold-text hover:underline" data-testid="goto-login">Se connecter</Link>
        </div>
      </div>
    </div>
  );
}

function Field({ label, type, value, onChange, testid }) {
  return (
    <label className="block">
      <span className="label-eyebrow block mb-2">{label}</span>
      <input
        type={type}
        value={value}
        onChange={(e)=>onChange(e.target.value)}
        required
        data-testid={testid}
        className="w-full bg-[#0a0e0b] border border-[rgba(253,251,247,0.1)] px-4 py-3 text-[#fdfbf7] focus:border-[#d4af37] focus:outline-none transition-colors"
      />
    </label>
  );
}
